<template>
  <b-progress class="position-relative">
    <b-progress-bar :max="parts.max" :value="parts.confirmed" class="progress-bar-striped" :class="'requisite-fill-confirmed--' + barStatus"></b-progress-bar>
    <b-progress-bar :max="parts.max" :value="parts.frozen" class="progress-bar-striped requisite-fill-frozen"></b-progress-bar>
    <small class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(total) }}/{{ numberFormatter.formatNumber(limit) }}</small>
  </b-progress>
</template>

<script lang="ts">

import {computed, defineComponent, PropType} from 'vue'
import {BProgress, BProgressBar} from "bootstrap-vue-3";
import MoneyDTO from "@/models/MoneyDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {resolveBarStatus, splitSum} from "@/service/requisiteFrozenSums";

export default defineComponent({
  components: {
    BProgress,
    BProgressBar,
  },
  props: {
    total: {
      type: Object as PropType<MoneyDTO>,
      required: true,
    },
    frozen: {
      type: Object as PropType<MoneyDTO | null>,
      default: null,
    },
    limit: {
      type: Object as PropType<MoneyDTO>,
      required: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const parts = computed(() => splitSum(props.total, props.frozen, props.limit))
    const barStatus = computed(() => resolveBarStatus(props.total, props.limit, props.active))

    return {
      parts,
      barStatus,
      numberFormatter,
    }
  }
})
</script>
